import clsx from 'clsx';
import { ProductCategory } from 'screens/AccessExpressV3/accessExpress.types';
import { CloseCircleOutline } from 'react-ionicons';
import ServiceTypeTag, {
  ServiceType,
} from 'screens/AccessExpressV3/BaseComponents/SeviceType';

interface AccessServiceTileNotServiceableProps {
  category: ProductCategory;
  isActive?: boolean;
}

const AccessServiceTileNotServiceable = ({
  category,
  isActive = false,
}: AccessServiceTileNotServiceableProps) => (
  <div className="flex h-full flex-col">
    <header
      className={clsx(
        'relative flex min-h-[124px] flex-col items-start justify-center gap-2 rounded-t-2xl p-3',
      )}
    >
      <div
        className={clsx(
          'flex flex-row gap-1 whitespace-nowrap text-sm font-bold group-hover:text-content-base-default',
          isActive ? 'text-content-base-default' : 'text-content-base-subdued',
        )}
      >
        <span>Not serviceable</span>
        <CloseCircleOutline color="currentColor" width="20px" height="20px" />
      </div>
      <div className="text-xs font-semibold">
        {category} services are not currently available at this location.
      </div>
      <span className="absolute right-3 top-3 opacity-50">
        <ServiceTypeTag
          type={category as ServiceType}
          disabled
          className="ml-4 max-h-6 w-[85px]"
          labelClassName="whitespace-nowrap"
        />
      </span>
    </header>
  </div>
);

export default AccessServiceTileNotServiceable;
